(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-spec-compare"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', () => {
    const stickyProducts = document.querySelector('#sticky_products');
    const stickyProductWrapper = document.querySelector('#sticky_products .sticky-products-wrapper');
    const specGrid = document.querySelector('.grid-container');

    document.addEventListener('scroll', () => {
      const { top } = specGrid.getBoundingClientRect();

      if (top <= 100) {
        stickyProducts.classList.add('is-sticky');
      } else {
        stickyProducts.classList.remove('is-sticky');
      }
    });

    if (window.innerWidth >= 750) {
      stickyProductWrapper.addEventListener('scroll', () => {
        specGrid.scrollLeft = stickyProductWrapper.scrollLeft;
      });

      specGrid.addEventListener('scroll', () => {
        stickyProductWrapper.scrollLeft = specGrid.scrollLeft;
      });
    } else {
      specGrid.addEventListener('scroll', () => {
        stickyProductWrapper.style.marginLeft = -1 * specGrid.scrollLeft + 'px';
      });
    }

    const collapsedHeight = specGrid.clientHeight;
    specGrid.classList.add('view-all');
    let expandedHeight = specGrid.clientHeight;

    setTimeout(() => { 
      expandedHeight = specGrid.clientHeight;
      collapseSection(specGrid);
    }, 500);

    function collapseSection(element) {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.clientHeight;
  
      // temporarily disable all css transitions
      var elementTransition = element.style.transition;
      element.style.transition = '';
  
      // on the next frame (as soon as the previous style change has taken effect),
      // explicitly set the element's height to its current pixel height, so we
      // aren't transitioning out of 'auto'
      requestAnimationFrame(function() {
        element.style.height = expandedHeight + 'px';
        element.style.transition = elementTransition;
  
        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function() {
          element.style.height = collapsedHeight + 'px';
        });
      });
  
      // mark the section as "currently collapsed"
      element.setAttribute('data-collapsed', 'true');
    }
  
    function expandSection(element) {
      // get the height of the element's inner content, regardless of its actual size
      var sectionHeight = element.clientHeight;
  
      // have the element transition to the height of its inner content
      element.style.height = expandedHeight + 'px';
  
      // when the next css transition finishes (which should be the one we just triggered)
      element.addEventListener('transitionend', function(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', arguments.callee);
  
        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = expandedHeight + 'px';
      });
  
      // mark the section as "currently not collapsed"
      element.setAttribute('data-collapsed', 'false');
    }

    document.querySelector('.view-all-wrapper button').addEventListener('click', (e) => {
      const buttonElem = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('button');
      const section = document.querySelector('.grid-container');
      const isCollapsed = section.getAttribute('data-collapsed') === 'true';
  
      buttonElem.innerText = buttonElem.innerText === 'View All' ? 'View Less' : 'View All';
  
      if(isCollapsed) {
        expandSection(section);
        section.setAttribute('data-collapsed', 'false');
      } else {
        collapseSection(section);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
